import { Button, Box } from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useLocation } from "react-router-dom";

const BannerPreview = ({ eventId }) => {
  const location = useLocation();
  if (!eventId) return null;
  if (location.pathname.includes('/preview/')) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 22,
        /* left: 0, */
        width: '100%',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'start',
        pointerEvents: 'none',
      }}
    >
      <Button
        variant="contained"
        startIcon={<VisibilityOutlinedIcon />}
        sx={{
          backgroundColor: "#5656ff",
          color: "white",
          fontFamily: "Bricolage Grotesque",
          borderRadius: 8,
          boxShadow: 3,
          fontWeight: 700,
          fontSize: 18,
          px: 4,
          py: 1.5,
          pointerEvents: 'auto',
        }}
        onClick={() => window.open(`/eventos/preview/${eventId}`, '_blank')}
      >
        Vista previa del evento
      </Button>
    </Box>
  );
};

export default BannerPreview;